var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircleFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4814_29046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 25.3043 37.8929 30.3914 34.1421 34.1421C30.3914 37.8929 25.3043 40 20 40C14.6957 40 9.60859 37.8929 5.85786 34.1421C2.10714 30.3914 0 25.3043 0 20C0 14.6957 2.10714 9.60859 5.85786 5.85786C9.60859 2.10714 14.6957 0 20 0C25.3043 0 30.3914 2.10714 34.1421 5.85786C37.8929 9.60859 40 14.6957 40 20ZM30.075 12.425C29.8964 12.247 29.6838 12.1069 29.4498 12.013C29.2159 11.9191 28.9654 11.8734 28.7133 11.8785C28.4613 11.8837 28.2128 11.9396 27.9829 12.0429C27.7529 12.1463 27.5462 12.2949 27.375 12.48L18.6925 23.5425L13.46 18.3075C13.1046 17.9763 12.6344 17.796 12.1487 17.8046C11.6629 17.8131 11.1995 18.0099 10.8559 18.3534C10.5124 18.697 10.3156 19.1604 10.3071 19.6462C10.2985 20.1319 10.4788 20.6021 10.81 20.9575L17.425 27.575C17.6032 27.7529 17.8154 27.893 18.049 27.9871C18.2825 28.0812 18.5326 28.1273 18.7844 28.1226C19.0361 28.118 19.2843 28.0627 19.5142 27.96C19.7441 27.8573 19.951 27.7094 20.1225 27.525L30.1025 15.05C30.4427 14.6962 30.6307 14.2232 30.626 13.7324C30.6213 13.2416 30.4244 12.7722 30.0775 12.425H30.075Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4814_29046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFill);
export default __webpack_public_path__ + "static/media/check-circle-fill.2840ccc54679f1e406d076bc325d1fbe.svg";
export { ForwardRef as ReactComponent };